export interface IDotRezSellTripRequestWrapper {
    journeysToCancel: string[];
    ssrsToRemove: string[];
    sellTripRequest: IDotRezSellTripRequest;
}


export interface IDotRezSellTripPassengerType {
    type: string;
    discountCode?: string;
    count: number;
}

export enum InventoryControlGraphQLEnum {
    HoldSpace = "HoldSpace",
    SoftHoldSpace = "SoftHoldSpace",
    ClaimSpace = "ClaimSpace",
    OversellSpace = "OversellSpace",
    StandBy = "StandBy"
}

export interface IDotRezSellTripRequest {
    preventOverlap: boolean,
    keys: Array<{
        journeyKey: string;
        fareAvailabilityKey: string;
        standbyPriorityCode?: string;
        inventoryControl?: InventoryControlGraphQLEnum;
    }>;
    passengers: {
        types: IDotRezSellTripPassengerType[];
    };
    currencyCode: string;
    infantCount?: number;
}
